export const DNI = 'DNI';

export const CARNET_EXTRANJERIA = 'C.E.';

export const RUC = 'RUC';

export const SIMBOLO_SOL = 'S/';

export const SIMBOLO_DOLAR = 'US$';

export enum SimuladorMensajeExcedenteEnum {
  TIENE_EXCEDENTE = 'El contrato cuenta con un excedente de',
  SIN_EXCEDENTE = 'El contrato no cuenta con excedente'
}

export enum AlertMensajes {
  Success = 'Los datos se han guardado exitosamente'
}

export enum FormElement {
  INPUT = 'INPUT',
  SELECT = 'SELECT',
  DATE = 'DATE',
  CHECKBOX = 'CHECKBOX',
  TEXT = 'TEXT',
  AUTO_COMPLETE = 'AUTO_COMPLETE'
}

export enum TiposPersona {
  NATURAL = 'NATURAL',
  JURIDICO = 'JURÍDICA'
}



// WEBPACK FOOTER //
// ./src/app/@compartidos/compartidos.enum.ts